var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultiap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1111 4H4.88889C4.39797 4 4 4.39797 4 4.88889V11.1111C4 11.602 4.39797 12 4.88889 12H11.1111C11.602 12 12 11.602 12 11.1111V4.88889C12 4.39797 11.602 4 11.1111 4Z",
    stroke: "#353E5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61263 7.66667C7.07287 7.66667 7.44596 7.29357 7.44596 6.83333C7.44596 6.3731 7.07287 6 6.61263 6C6.15239 6 5.7793 6.3731 5.7793 6.83333C5.7793 7.29357 6.15239 7.66667 6.61263 7.66667Z",
    fill: "#353E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 9.3355L9.77756 7.11328L4.88867 12.0022",
    stroke: "#353E5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2283_119842)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99958 15.1654H13.333C14.3455 15.1654 15.1663 14.3446 15.1663 13.332V9.99942H14.1663V13.332C14.1663 13.7923 13.7932 14.1654 13.333 14.1654H9.99958V15.1654ZM9.99959 1.83203H13.333C13.7932 1.83203 14.1663 2.20513 14.1663 2.66536V5.99942H15.1663V2.66536C15.1663 1.65284 14.3455 0.832031 13.333 0.832031H9.99959V1.83203ZM5.99959 0.832031V1.83203H2.66634C2.2061 1.83203 1.83301 2.20513 1.83301 2.66537V5.99942H0.833008V2.66537C0.833008 1.65284 1.65382 0.832031 2.66634 0.832031H5.99959ZM5.99958 14.1654V15.1654H2.66634C1.65382 15.1654 0.833008 14.3446 0.833008 13.332V9.99942H1.83301V13.332C1.83301 13.7923 2.2061 14.1654 2.66634 14.1654H5.99958Z",
    fill: "#353E5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2283_119842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultiap);
export default __webpack_public_path__ + "static/media/defaultiap.42528f2064f915db4c31f4f84173f878.svg";
export { ForwardRef as ReactComponent };